import React, { useState } from 'react';
import face from '../assets/face1.png';
import '../styles/MonalisaImage.css';

export default function MonalisaImage() {
    const [showHello, setShowHello] = useState(false);

    function handleMonalisaClick() {
        setShowHello(true);
        setTimeout(() => {
            setShowHello(false);
        }, 3000); // Hide after 3 seconds
    }

    return (
        <div className="monalisa-container">
            <img src={face} alt="Monalisa-with-glasses" className='monalisa' onClick={handleMonalisaClick} />
            {showHello && <div className="hello-message">Hello</div>}
        </div>
    );
}
